<template>
  <div class="searchCategories">
    <template v-if="searchPage && categoryFilter && categoryFilter.slug">
      <nuxt-link
        :to="
          localePath({
            name: 'category-slug',
            params: { slug: categoryFilter.slug },
            ...(!categoryFilter.showCategoryView && { query: $route.query }),
          })
        "
        class="searchCategories__prev"
      >
        {{ categoryFilter.title }}
      </nuxt-link>
    </template>
    <template v-else>
      <button
        v-if="categoryFilter && categoryFilter.id"
        class="searchCategories__prev"
        @click="selectCategory(categoryFilter.id)"
      >
        {{ categoryFilter.title }}
      </button>
      <button
        v-else-if="categoryLevel === 0"
        class="searchCategories__prev"
        @click="selectCategory()"
      >
        Wszystkie kategorie
      </button>
      <button v-else class="searchCategories__prev searchCategories__prev--hideArrow">
        Wszystkie kategorie
      </button>
    </template>
    <ul v-if="categoryFilter && categoryFilter.list" class="searchCategories__list">
      <li
        v-for="category in categoryFilter.list"
        :key="category.id"
        class="searchCategories__listItem"
      >
        <nuxt-link
          v-if="searchPage && category.slug"
          :to="
            localePath({
              name: 'category-slug',
              params: { slug: category.slug },
              ...(!category.showCategoryView && { query: $route.query }),
            })
          "
          :class="[
            'searchCategories__listButton',
            { 'searchCategories__listButton--active': category.selected },
          ]"
        >
          {{ category.title }}
          <span class="searchCategories__listAvailable">{{ category.count }}</span>
        </nuxt-link>
        <button
          v-else
          :class="[
            'searchCategories__listButton',
            { 'searchCategories__listButton--active': category.selected },
          ]"
          @click="selectCategory(category.id)"
        >
          {{ category.title }}
          <span class="searchCategories__listAvailable">{{ category.count }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SearchCategories',
  props: {
    searchPage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      categoryFilter: state => state.productsFilters.search.categoryFilter,
      categoryLevel: state => state.productsFilters.search.categoryLevel,
    }),
  },
  methods: {
    ...mapActions({
      changeCategory: 'productsFilters/changeCategory',
    }),
    selectCategory(id) {
      this.$emit('select');
      if (id) {
        this.changeCategory({ type: 'search', value: [id] });
      } else {
        this.changeCategory({ type: 'search', value: [] });
      }
    },
  },
};
</script>

<style lang="scss">
.searchCategories {
  $root: &;
  margin-bottom: 1.6rem;
  background-color: $cWhite;

  &__prev {
    display: flex;
    align-items: center;
    padding: 2rem;
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 600;
    border-bottom: 1px solid $cAddLight;
    width: 100%;
    text-align: left;

    &:before {
      @include icomoon('chevron-left-bold');
      font-size: 1rem;
      padding-right: 2rem;
    }

    &--hideArrow {
      &:before {
        display: none;
      }
    }
  }

  &__list {
    padding: 2rem;
  }

  &__listItem {
    &:last-child {
      #{$root}__listButton {
        margin-bottom: 0.3rem;
      }
    }
  }

  &__listButton {
    display: flex;
    margin-bottom: 1rem;
    justify-content: space-between;
    text-align: left;
    font-size: 1.4rem;
    line-height: 2.2rem;
    color: $cMainLight;
    width: 100%;
    transition: color $tr;

    &:hover,
    &--active {
      color: $cSec;
    }
  }

  &__listAvailable {
    color: $cAddDark02;
  }
}
</style>
